(function () {
  const STORAGE_KEY = 'cc_nanami_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateWishlistCount();
    updateButtons();
  }

  function isInWishlist(productId) {
    return getWishlist().some(item => String(item.id) === String(productId));
  }

  function addToWishlist(product) {
    const items = getWishlist();

    if (!items.some(item => String(item.id) === String(product.id))) {
      items.push(product);
      saveWishlist(items);
    }
  }

  function removeFromWishlist(productId) {
    const items = getWishlist().filter(item => String(item.id) !== String(productId));
    saveWishlist(items);
  }

  function updateWishlistCount() {
    const count = getWishlist().length;

    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.setAttribute('data-count', String(count));
    });
  }

  function updateButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(button => {
      const productId = button.getAttribute('data-product-id');

      if (isInWishlist(productId)) {
        button.classList.add('is-active');
        button.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        button.classList.remove('is-active');
        button.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  function initWishlistButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(button => {
      if (button.dataset.wishlistReady === 'true') return;
      button.dataset.wishlistReady = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const product = {
          id: button.getAttribute('data-product-id'),
          title: button.getAttribute('data-product-title'),
          url: button.getAttribute('data-product-url'),
          image: button.getAttribute('data-product-image'),
          price: button.getAttribute('data-product-price')
        };

        if (!product.id) return;

        if (isInWishlist(product.id)) {
          removeFromWishlist(product.id);
        } else {
          addToWishlist(product);
        }
      });
    });

    updateWishlistCount();
    updateButtons();
  }

  document.addEventListener('DOMContentLoaded', initWishlistButtons);
  document.addEventListener('shopify:section:load', initWishlistButtons);

  window.CCNanamiWishlist = {
    getWishlist,
    addToWishlist,
    removeFromWishlist,
    updateWishlistCount
  };
})();

/* Header wishlist icon link fix */
document.addEventListener('DOMContentLoaded', function () {
  const wishlistPageUrl = '/pages/wishlist-1';

  function setupHeaderWishlistLink() {
    const header = document.querySelector('header, .header, .shopify-section-header');
    if (!header) return;

    let wishlistTrigger =
      header.querySelector('a[href*="wishlist"]') ||
      header.querySelector('[aria-label*="Wishlist"]') ||
      header.querySelector('[aria-label*="wishlist"]') ||
      header.querySelector('[class*="wishlist"]') ||
      header.querySelector('[data-wishlist-header]');

    if (!wishlistTrigger) {
      const possibleButtons = header.querySelectorAll('a, button');

      possibleButtons.forEach(function (el) {
        if (wishlistTrigger) return;

        const svg = el.querySelector('svg');
        const badge = el.querySelector('[class*="badge"], [class*="count"], sup, .cart-count-bubble');

        if (svg && badge && !el.closest('[class*="cart"]')) {
          wishlistTrigger = el;
        }
      });
    }

    if (!wishlistTrigger) return;

    if (wishlistTrigger.tagName.toLowerCase() === 'a') {
      wishlistTrigger.setAttribute('href', wishlistPageUrl);
    } else {
      wishlistTrigger.style.cursor = 'pointer';

      wishlistTrigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        window.location.href = wishlistPageUrl;
      });
    }
  }

  setupHeaderWishlistLink();

  document.addEventListener('shopify:section:load', function () {
    setupHeaderWishlistLink();
  });
});